import request from '../request';

export const refund = ({ orderId, eventId, agree_refund, uidTickets }) => request({
  url: '/refund',
  data: {
    order_id: orderId,
    event_id: eventId,
    agree_refund,
    uids: uidTickets,
  },
});

/**
 * Позволяет провести возврат билетов по переданному массиву uid
 * @param {number} orderId - номер заказа
 * @param {number[]} uids - массив идентификаторов билетов, подлежащих возврату
 * @return {Promise<{ sucess: boolean, message => string }>}
 */
export const refundByUids = ({ orderId, uids }) => request({
  url: '/refund/refund',
  data: {
    orderId,
    uids,
  },
});

/**
 * Получение билетов доступных к возврату по номеру заказа
 * @param {number} orderId - номер заказа
 * @return {Promise<{ sucess: boolean, message => string }>}
 */
export const getRefundCarts = ({ orderId }) => request({
  url: '/refund/get-refund-carts',
  data: {
    orderId,
  },
});